// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import type { ActiveClaimSession } from '@/services/claimSession';
import { getUsableJwt } from '@/services/jwt';

export const hasClaimAccess = (claimSession: ActiveClaimSession | null | undefined): boolean =>
  !!getUsableJwt(claimSession?.claimAccessToken);

export const appendClaimQuery = (
  url: string,
  claimSession: ActiveClaimSession | null | undefined,
): string => {
  if (!claimSession) {
    return url;
  }

  const claimToken = getUsableJwt(claimSession.claimAccessToken);
  const claimClientId = claimSession.claimClientId?.trim();
  const inviteToken = claimSession.inviteToken?.trim();
  if (!claimToken && !claimClientId && !inviteToken) {
    return url;
  }

  const params = new URLSearchParams();
  if (claimToken) {
    params.set('claimToken', claimToken);
  }
  if (claimClientId) {
    params.set('claimClientId', claimClientId);
  }
  if (inviteToken) {
    params.set('inviteToken', inviteToken);
  }

  const query = params.toString();
  if (!query) {
    return url;
  }

  return `${url}${url.includes('?') ? '&' : '?'}${query}`;
};

export const buildAccessHeaders = (userToken?: string | null): HeadersInit | undefined => {
  const normalized = userToken?.trim();
  if (!normalized) {
    return undefined;
  }

  return {
    Authorization: `Bearer ${normalized}`,
  };
};
